module.exports = __webpack_public_path__ + "img/frame (133).28f4c325.jpg";